import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createType,
  getAllTypes,
  toggleTypeStatus,
  updateType,
} from "./types.service";

const key = "jeep-rally-types";

export const useGetAllTypes = (params = {}, options = {}) => {
  const status = params?.status || "";

  return useQuery({
    queryKey: [key, status],
    queryFn: () => getAllTypes(params),
    ...options,
  });
};

export const useCreateTypeMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createType,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [key] });
    },
  });
};

export const useUpdateTypeMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ typeId, formData }) => updateType(typeId, formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [key] });
    },
  });
};

export const useToggleTypeStatusMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: toggleTypeStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [key] });
    },
  });
};
